import { useState } from "react";
import API from "../../Api/axiosConfig";
import { Form, Container, Row, Col, Card } from "react-bootstrap";
import MyInput from "../../Components/Myinput";
import MyButton from "../../Components/MyButton";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function Register() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        password: "",
        password_confirmation: "",
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const res = await API.post("/register", formData);

            if (res.data.status) {
                localStorage.setItem("token", res.data.data.token);
                toast.success(res.data.message || "تم إنشاء الحساب بنجاح");
                setTimeout(() => {
                    navigate("/login");
                }, 1500);
            }
        } catch (err) {
            if (err.response?.data?.errors) {
                Object.values(err.response.data.errors).forEach((msg) =>
                    toast.error(msg[0])
                );
            } else {
                toast.error("فشل إنشxاء الحساب");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container fluid className="vh-100 login-con">
            <Row className="h-100">
                <Col md={6} className="login-image d-none d-md-block"></Col>

                <Col md={6} className="d-flex justify-content-center align-items-center">
                    <Card className="shadow-lg p-5 rounded-4 login-card w-75">
                        <Card.Body dir="rtl">
                            <h2 className="text-center mb-4">إنشاء حساب</h2>
                            <Form onSubmit={handleSubmit}>
                                <MyInput
                                    label="الاسم"
                                    name="name"
                                    type="text"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                                <MyInput
                                    label="البريد الإلكتروني"
                                    name="email"
                                    type="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                                <MyInput
                                    label="كلمة المرور"
                                    name="password"
                                    type="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                />
                                <MyInput
                                    label="تأكيد كلمة المرور"
                                    name="password_confirmation"
                                    type="password"
                                    value={formData.password_confirmation}
                                    onChange={handleChange}
                                    required
                                />
                                <MyButton text="تسجيل" loading={loading} />
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default Register;
